import { useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import GapHeader from "../components/GapHeader";
import SacristanContact from "../components/SacristanContact";
import DraftPanel from "../components/DraftPanel";
import ShortlistPanel from "../components/ShortlistPanel";
import VolunteersButton from "../components/VolunteersButton";
import Modal from "../components/Modal";
import Spinner from "../components/Spinner";
import { useGap } from "../lib/useGap";
import { payloadTimeZone } from "../lib/timezone";

export default function GapModal() {
  const { gapId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const { data, error, loading } = useGap(gapId);
  const initialDraft = searchParams.get("draft") === "sacristan";
  const [draftOpen, setDraftOpen] = useState(initialDraft);
  const [volunteersOpen, setVolunteersOpen] = useState(false);

  const close = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate("/", { replace: true });
  };

  const closeDraft = () => {
    setDraftOpen(false);
    if (searchParams.has("draft")) {
      const next = new URLSearchParams(searchParams);
      next.delete("draft");
      setSearchParams(next, { replace: true });
    }
  };

  return (
    <Modal open onClose={close} ariaLabel="Sub-request detail">
      {loading ? (
        <Spinner label="Loading sub-request" />
      ) : error || !data ? (
        <p className="placeholder">Couldn't load this gap{error ? `: ${error}` : ""}.</p>
      ) : (
        <>
          <GapHeader gap={data.gap} timeZone={payloadTimeZone(data.timezone)} />
          <SacristanContact
            sacristan={data.gap.sacristan}
            onDraftEmail={() => setDraftOpen(true)}
          />

          <VolunteersButton
            open={volunteersOpen}
            onToggle={() => setVolunteersOpen((v) => !v)}
          >
            <ShortlistPanel gap={data.gap} forceVisible />
          </VolunteersButton>

          {data.gap.sacristan ? (
            <DraftPanel
              open={draftOpen}
              onClose={closeDraft}
              gapId={data.gap.id}
              recipient="sacristan"
            />
          ) : null}
        </>
      )}
    </Modal>
  );
}
